import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { screenMessage } from "../lib/screenMessage";
import { inAppPath } from "../lib/inAppPath";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "working", message: "Confirming your email…" });
  const [pending2fa, setPending2fa] = useState("");
  const [code, setCode] = useState("");
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;  // the link works once: don't post it twice (StrictMode)
    done.current = true;
    const token = params.get("token") || "";
    window.history.replaceState({}, document.title, "/verify-email");  // keep the token out of history
    axios.post(`${API}/auth/verify-email`, { token })
      .then((r) => {
        if (r.data?.staff_sign_in_required) {
          setState({ status: "ok", message: "Staff accounts sign in at /admin/login." });
          navigate(inAppPath(r.data.next, "/admin/login"), { replace: true });
          return;
        }
        if (r.data?.requires_2fa) {
          setPending2fa(r.data.pending_2fa || "");
          setState({ status: "ok", message: "Your email is confirmed. Enter the authenticator code to finish signing in." });
          return;
        }
        setState({ status: "ok", message: r.data?.signed_in
          ? "Your email is confirmed and you're signed in. You can run the agent now."
          : "Your email is confirmed." });
        refresh();
      })
      .catch(() => {
        setState({ status: "error", message: screenMessage("login") });
      });
  }, [params, refresh, navigate]);
  const submitCode = (e) => {
    e.preventDefault();
    axios.post(`${API}/auth/2fa`, { pending_2fa: pending2fa, code: code.trim() }, { withCredentials: true })
      .then(() => {
        setPending2fa("");
        setState({ status: "ok", message: "Your email is confirmed and you're signed in. You can run the agent now." });
        refresh();
      })
      .catch(() => {
        setState({ status: "error", message: screenMessage("twofa") });
      });
  };
  return (
    <div className="mx-auto max-w-md px-6 py-24 text-center" data-testid="verify-email-page">
      <h1 className="font-display text-2xl font-bold">Email confirmation</h1>
      <p className={`mt-4 text-sm ${state.status === "error" ? "text-red-600" : "text-muted-foreground"}`} data-testid="verify-email-status">{state.message}</p>
      {pending2fa && (
        <form onSubmit={submitCode} className="mt-6">
          <input className="w-full rounded border px-3 py-2" value={code} onChange={(e) => setCode(e.target.value)}
                 autoComplete="one-time-code" placeholder="123456" data-testid="verify-email-2fa-code" />
          <button type="submit" className="mt-3 underline" data-testid="verify-email-2fa-submit">Continue</button>
        </form>
      )}
      <div className="mt-8 flex justify-center gap-4 text-sm">
        <Link className="underline" to="/workspace">Go to the workspace</Link>
        <Link className="underline" to="/settings">Settings</Link>
      </div>
    </div>
  );
}
